import { hasSendBeacon } from '../common/utils/navigator';
import ContentConfig from '../config/ContentConfig';
import RequestError from '../error/RequestError';
import getUrlPrefix from './getUrlPrefix';

export default async function endSession(
  config: ContentConfig,
  {
    tenantId,
    contentId,
    playGuid
  }: {
    tenantId: string;
    contentId: string;
    playGuid: string;
  }
): Promise<void> {
  const urlPrefix = getUrlPrefix(config);
  const url = `${urlPrefix}:${config.agent.port}/tenant/${tenantId}/content/${contentId}/session/${playGuid}/delete`;

  let ok = false;
  let status = 500;
  if (hasSendBeacon()) {
    ok = window.navigator.sendBeacon(url);
    status = ok ? 200 : 500;
  } else {
    const resp = await fetch(url, {
      method: 'POST'
    });
    ok = resp.ok;
    status = resp.status;
  }

  if (ok) {
    return Promise.resolve();
  } else {
    return Promise.reject(new RequestError('Request failed', status));
  }
}
